import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './components/ui-kit/tokens.css';
import './i18n';
import App from './App';
import { registerServiceWorker } from './lib/registerSW';

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

// -----------------------------
// SENTRY INIT
// -----------------------------
Sentry.init({
  dsn: "https://32db61790de2a3f9bf4e7b2a13792702@o4511422797316096.ingest.de.sentry.io/4511422818091088",
  integrations: [
    new BrowserTracing(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: "production",
});

// -----------------------------
// REACT ROOT
// -----------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// -----------------------------
// PWA SERVICE WORKER
// -----------------------------
registerServiceWorker();
